module.exports = {
  Subject: "Account Verification link",
  body:
    "Hello,\n\n" + "Please verify your account by clicking the link: \nhttp://",
  Adminlink: "/#confirmation?",
  adminMailID: "",
  //'createEUonRegistration': true, // when true, user will create created in db
  CentralServer: "https://workwithfriends.fourcolorstech.com",
  ProxyURL: "",
  IsSateliteServer: false,
  helpFolderName: "helpFolder/",
  releaseNotesFolderName: "releaseNotes/",
  migrationLogFile: "mig/mig-logs.log",
  SessionExpiresIn: "8h", //Eg: "10h", "7d" Default milliseconds
  ExternalUserSessionExpiresIn: "2h",
  ArchiveJobsAfterDays: 30,
  JobArchivalTime: "1:30", //24 hr format
  JobArchivalDay: 7, //Sat
  provisionPeriodCompletedDays: 180, //send mail after 180 days 
  InactiveOldUserDays: 1080,
  ApproverGroup: ["Global Approvers"],
  JobArchivalTest: true,
  ElasticSearch: false,
  InactiveOldUsernotificationDay: 7,
  ToggleOldUserInactive: true,
  globalSupportEmail: "hello@fourcolorstech.com",
  mailPostAPI: "", //Flow URL for approval mails
  MSALMail: true,
  clientId: "a15777e3-4888-43cf-8a68-8862386f024d",
  authority:
    "https://login.microsoftonline.com/97bf83c4-b171-4abc-9a9b-09310d0c1c90",
  clientSecret: "vLb8Q~pzIwEbvPKf-PNLrRVqsTxw8ArWSt~KdaUN",
  mailEndpoint:
    "https://graph.microsoft.com/v1.0/users/hello@fourcolorstech.com/sendMail",
  allowedUsersToLogin:
    "vasanth.kumar@fourcolorstech.com,jayasree@fourcolorstech.com,apiclient1@dxportal.com,DXdba@dxportal.com,vamsi,sheeba.varghese@fourcolorstech.com",
  enableMoveFileToRootJobDir: false,
  RestrictedDomain: "",
  noSQLDBAccess: true,
  adminAuthKeyAuthentication: false,
  adminAuthKeyByPassforEXTSYS: true,
  togglefileCleanup: true,
  edxText: "Work With Friends",
  organizationName: "FourColors India Pvt. Ltd.",
  cleanupFolders: "tempZip,uploads//tmp,uploads//Job,tempZip//Job",
  externalUserLoginType: 1, // 0 -> none, 1 -> OTP only EU , 2 -> OTP ALL Role
  isServerHttp: true,
  ToggleIAFailedJobNotification: true,
  hrSupport: {
    hrName: "HR Team",
    hrEmail: "HRSupport@fourcolorstech.com",
  },
  fctIndia: "FCTIndia@fourcolorstech.com",
  fctImg: "https://referralportal.eastus.cloudapp.azure.com/images/fctlogo.svg",
  edxSign: "https://i.ibb.co/tM0zpVjB/Screenshot-2025-06-24-135118.png",
  privacyPolicy: "https://www.fourcolorstech.com/",
  EdxImg: "https://imghost.net/ib/m2VUAvkl99lcHm4_1750341029.png",
  AutoUserCreation: true,

};
